import { jackPotStore } from '../../store/jackPotStore';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';
import { jackpotConnection } from '../socketConnection/jackpotConnection';

class JackpotService {
  handleJackpotResult(data) {
    jackPotStore.setJackpotAmounts(data);
  }

  handleJackpotWin(data) {
    jackPotStore.setJackpotWinInfo(data);
  }

  handleBoostedJackpotWinnerInfoResult(data) {
    const {
      winAmount,
      leftWinsCount,
      leftPoolSize,
      lastWin,
      lastWinDate,
      largestWin,
      largestWinDate,
    } = data;
    const {
      setLastWinnerDate,
      setWinningCountLeft,
      setLastWinnerAmount,
      setLargestWinnerDate,
      setLargestWinnerAmount,
      setPrizePoolLeftAmount,
      setPlayerBoostedWinAmount,
    } = boostedJackpotStore;

    setLastWinnerAmount(lastWin);
    setLastWinnerDate(lastWinDate);
    setLargestWinnerAmount(largestWin);
    setWinningCountLeft(leftWinsCount);
    setLargestWinnerDate(largestWinDate);
    setPrizePoolLeftAmount(leftPoolSize);
    setPlayerBoostedWinAmount(winAmount);
  }

  handleJackpotWinnerInfoResult(data) {
    jackPotStore.setJackpotWinnerInfo(data);
  }

  handleReconnected() {
    jackpotConnection.sendGameGetInitialState(false);
  }
}

export const jackpotService = new JackpotService();
